module.exports = __webpack_public_path__ + "img/kq_quiz_night_creation.8d696131.png";